import AboutSubPage from "@/pages/about/components/AboutSubPage";

export default function CoreValuesFrPage() {
  return (
    <AboutSubPage
      heroImageSrc="https://net-basis.net/Bilder/netbasis-core-values-trust-partnership.webp"
      texts={{
        title: "Valeurs fondamentales",
        heroClaimLine1: "Avec des valeurs",
        heroClaimLine2: "vers le succès !",
        bottomClaim: "NetBasis International - drive to excellence with excellent drivers !",
      }}
      metaTitle="Nos Valeurs Fondamentales | NetBasis International"
      metaDescription="Respect, loyauté, professionnalisme, persévérance et confiance – les piliers fondamentaux de la réussite durable de nos fabricants partenaires."
      metaOgUrl="https://net-basis.net/fr/a-propos/valeurs-fondamentales"
    >
      <div className="space-y-4 text-foreground-950 leading-relaxed text-sm md:text-base">
        <h1 className="font-semibold text-foreground-950 text-sm md:text-base">
          Respect. Loyauté. Professionnalisme. Persévérance. Confiance.
        </h1>
        <p>Ce sont les valeurs fondamentales sur lesquelles NetBasis International s'appuie fermement et qui nous guident au quotidien dans notre travail. Elles nous accompagnent dans notre dévouement sans faille envers nos partenaires commerciaux et dictent la manière précise dont nous nous acquittons de nos responsabilités opérationnelles.</p>
        <p>C'est notre engagement quotidien envers nous-mêmes que de prouver durablement aux nouveaux partenaires qu'ils ont fait le choix absolument idéal à nos côtés, et de démontrer sans cesse à nos partenaires existants, dans le cadre de projets communs, qu'ils sont entre de très bonnes mains et parfaitement accompagnés.</p>
        <p>Votre réussite est notre obligation.</p>
      </div>
    </AboutSubPage>
  );
}